import {createContext, useContext, useState} from 'react';

const MenuContext = createContext();

export const useMobileMenu = () => {
    const {items, setExpandedIds, expandedIds, ...cx} = useContext(MenuContext);

    const expand = id => setExpandedIds([id].concat(expandedIds));
    const retract = id => setExpandedIds(expandedIds.filter(x => x !== id));
    const retractAll = () => setExpandedIds([]);
    const expandAll = () => setExpandedIds(cx.items.map(i => i.id));
    return {...cx, items, expandedIds, expand, retract, retractAll, expandAll};
};

export const useDesktopMenu = () => useContext(MenuContext);

export const MenuBoundary = ({value, ...props}) => {
    const [hoveredItem, setHoveredItem] = useState(null);
    const [expandedIds, setExpandedIds] = useState([]);
    return <MenuContext.Provider value={{...value, hoveredItem, setHoveredItem,
                                         expandedIds, setExpandedIds
                                         }} {...props} />;
};

MenuBoundary.displayName = 'MenuBoundary';

